import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaGaugeHigh, FaRightFromBracket } from "react-icons/fa6";

function Sidebar() {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <aside className="sidebar">
      {/* Dashboard Button */}
      <button className="sidebar-dashboard" onClick={() => navigate("/dashboard")}>
        <FaGaugeHigh className="icon" />
        <span>Dashboard</span>
      </button>

      {/* Pages Section */}
      <div className="sidebar-section">
        <p className="sidebar-label">PAGES</p>
        <ul className="sidebar-list">
          <ul className="sub-list">
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/quote-form")}>
                <span className="line">─</span> Health Insuarance
              </button>
            </li>
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/support-form")}>
                <span className="line">─</span> Support Form
              </button>
            </li>
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/notifyme-form")}>
                <span className="line">─</span> Upcoming Product
              </button>
            </li>
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/car-insuarance")}>
                <span className="line">─</span> Car Insuarance
              </button>
            </li>
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/job-applications")}>
                <span className="line">─</span> Job Applications
              </button>
            </li>
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/complimentory-pi")}>
                <span className="line">─</span> Complimentory Pi
              </button>
            </li>
            <li>
              <button className="sidebar-dashboard" onClick={() => navigate("/doctor-pi")}>
                <span className="line">─</span> Doctor Pi
              </button>
            </li>
          </ul>
        </ul>
      </div>

      {/* Logout Button */}
      <div className="sidebar-footer">
        <button className="logout" onClick={handleLogout}>
          <FaRightFromBracket className="icon" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
